module.exports = __webpack_public_path__ + "media/images/payment-5-7b36896743e597899947736633b6b76a.svg";